import Marquee from "react-fast-marquee";
import { useLanguage } from "../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-foreground/10 py-12 md:py-16 overflow-hidden"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif font-light text-2xl md:text-4xl text-foreground/45 tracking-tight whitespace-nowrap px-8 md:px-14">
              {item}
            </span>
            <span className="text-foreground/25 text-xl">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
